import api from './api';
import { CheckoutConfig, ApiConfig, SystemConfig } from '../interfaces/Config';

export const configService = {
  // Checkout Configuration — usa a rota real do backend: GET/PATCH /checkout/config
  async getCheckoutConfig(): Promise<CheckoutConfig> {
    const response = await api.get('/checkout/config');
    return response.data;
  },

  async updateCheckoutConfig(config: Partial<CheckoutConfig>): Promise<CheckoutConfig> {
    const response = await api.patch('/checkout/config', config);
    return response.data;
  },

  // API Configuration
  async getApiConfig(): Promise<ApiConfig> {
    const response = await api.get('/admin/config/api');
    return response.data;
  },

  async updateApiConfig(config: Partial<ApiConfig>): Promise<ApiConfig> {
    const response = await api.put('/admin/config/api', config);
    return response.data;
  },

  // System Configuration
  async getSystemConfig(): Promise<SystemConfig> {
    const response = await api.get('/admin/config/system');
    return response.data;
  },

  async updateSystemConfig(config: Partial<SystemConfig>): Promise<SystemConfig> {
    const response = await api.put('/admin/config/system', config);
    return response.data;
  },

  // Test API connection
  async testApiConnection(url: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/admin/config/test-api', { url });
    return response.data;
  },

  // Reset configuration to defaults
  async resetConfig(type: 'checkout' | 'api' | 'system'): Promise<void> {
    await api.post(`/admin/config/reset/${type}`);
  }
};